/** Global footer — shared chrome. */
export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white px-6 py-4 text-center text-xs text-slate-500">
      © {new Date().getFullYear()} LearnX. Premium one-to-one learning.
    </footer>
  );
}
